import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GrupoService } from '../../../../services/grupo.service';
import { EmpresaService } from '../../../../services/empresa.service';
import { MesService } from '../../../../services/mes.service';
import { AnioService } from '../../../../services/anio.service';
import { ExcepcionService } from '../../../../services/excepcion.service';
import { TipodeclaracionService } from '../../../../services/tipodeclaracion.service';

@Component({
  selector: 'app-agrdeclaracion',
  templateUrl: './agrdeclaracion.component.html',
  styleUrls: ['./agrdeclaracion.component.css'],
  providers: [TipodeclaracionService, GrupoService, EmpresaService, MesService, AnioService, ExcepcionService]
})
export class AgrdeclaracionComponent implements OnInit {
  public identity;
  public token;
  public status;
  public message_success;
  public message_error;
  public empresas: any = null;
  public meses: any = null;
  public anios: any = null;
  public excepciones: any = null;
  public tipo_declaraciones: any = null
  public showDates = null
  public showContainer = null

  constructor(
    private _router: Router,
    private _grupoService: GrupoService,
    private _empresaService: EmpresaService,
    private _mesService: MesService,
    private _anioService: AnioService,
    private _excepcionService: ExcepcionService,
    private _tipodeclaracionService: TipodeclaracionService,
  ) {
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {
    this.getEmpresas()
    this.getTipoDeclaraciones()
    this.getAnios()
  }

  showInfo(section) {
    console.log(section)
    if (section == 'dates') {
      this.showDates = true
    } else if (section == 'container') {
      this.showContainer = true
    } else { return false }
  }

  getEmpresas() {

    this._empresaService.getEmpresasActivas(this.token).subscribe(
      response => {
        if (response.status == 'success') {
          this.empresas = response.empresas;

        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existe problemas con el servidor, favor de intentar más tarde');
        }
      }
    );
  }

  getTipoDeclaraciones() {
    this._tipodeclaracionService.getTipoDeclaraciones(this.token).subscribe(
      response => {
        // Obtener el token 
        if (response.status == 'success') {
          this.tipo_declaraciones = response.tipoDeclaraciones;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existen problemas al querer comunicarse con el servidor, intente más tarde')
        }
      }
    );
  }

  getAnios() {
    this._anioService.getAniosHabilitados(this.token).subscribe(
      response => {
        if (response.status == 'success') {
          this.anios = response.anios;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existen problemas al querer comunicarse con el servidor, intente más tarde')
        }
      }
    );
  }

  getMesesHabilitados() {
    var anio_id = $("#anio_id").val();
    var empresa_id = $("#empresa_id").val();
    console.log(anio_id, empresa_id)
    this._mesService.getMesesHabilitados(this.token, anio_id, empresa_id).subscribe(
      response => {
        console.log(response)
        if (response.status == 'success') {
          this.meses = response.meses;
        }
      },
      error => {
        console.log(error)
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existe problemas con el servidor, favor de intentar más tarde');
        }
      }
    );
  }


}
